import * as React from 'react';
import { VtxButton, VtxIcon } from '@vertexinc/vtx-ui-react-component-library';
import FooterProps from './FooterProps.interface';
import '../../configuration.scss';

const Footer = ({
  onBack,
  backVisible = true,
  backEnabled = true,
  backText = 'Back',
  onCancel,
  cancelVisible = false,
  cancelEnabled = true,
  cancelText = 'Cancel',
  onNext,
  nextVisible = true,
  nextEnabled = true,
  nextText = 'Next',
}: FooterProps): JSX.Element => {
  const Spacer = () => <span style={{ marginRight: '20px' }} />;

  return (
    <>
      {/* Horizontal Line and Footer */}
      <hr />
      <div className="configurationFooter">
        <div className="configurationFooterLeft">
          {
            backVisible
            && (
              <div>
                <VtxButton
                  id="backButton"
                  icon={<VtxIcon type="left" />}
                  disabled={!backEnabled}
                  onClick={onBack}
                  type="default"
                >
                  {backText}
                </VtxButton>
              </div>
            )
          }
        </div>
        <div className="configurationFooterRight">
          {
            cancelVisible
            && (
              <div>
                <VtxButton
                  id="cancelButton"
                  icon={<VtxIcon type="stop" />}
                  disabled={!cancelEnabled}
                  onClick={onCancel}
                  iconDirection="left"
                  type="default"
                >
                  {cancelText}
                </VtxButton>
              </div>
            )
          }
          <Spacer />
          {
            nextVisible
            && (
              <div>
                <VtxButton
                  id="nextButton"
                  icon={<VtxIcon type="right" />}
                  disabled={!nextEnabled}
                  onClick={onNext}
                  iconDirection="right"
                  type="primary"
                >
                  {nextText}
                </VtxButton>
              </div>
            )
          }
        </div>
      </div>
    </>
  );
};

export default Footer;
